import { useState } from 'react';
import { useFeed } from '@/hooks/useFeed';
import { useSession } from '@/lib/auth-client';
import { FeedToggle } from '@/components/feed/FeedToggle';
import { PostList } from '@/components/feed/PostList';
import { WelcomeHero } from '@/components/home/WelcomeHero';
import { LoadingSpinner } from '@/components/shared/LoadingSpinner';
import { SEOHead } from '@/components/shared/SEOHead';

export function HomePage() {
  const { data: session, isPending } = useSession();
  const [activeTab, setActiveTab] = useState<'following' | 'foryou'>('foryou');

  const isLoggedIn = !isPending && !!session;

  // If not logged in, force "foryou" tab (Following requires auth)
  const effectiveTab = !isLoggedIn && activeTab === 'following' ? 'foryou' : activeTab;
  const feedType = effectiveTab === 'following' ? 'home' : 'discover';
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, error } =
    useFeed(feedType);

  const posts = data?.pages.flatMap((page) => page.posts) || [];

  if (error) {
    return (
      <div className="p-10 text-center">
        <p className="text-error mb-4 font-display">Failed to load feed</p>
        <button
          onClick={() => window.location.reload()}
          className="btn btn-primary"
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div>
      <SEOHead title="Home" />
      {!isPending && !session && <WelcomeHero />}
      <FeedToggle activeTab={effectiveTab} onTabChange={setActiveTab} showFollowing={isLoggedIn} />

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <PostList
          posts={posts}
          hasMore={!!hasNextPage}
          isLoading={isFetchingNextPage}
          onLoadMore={() => fetchNextPage()}
        />
      )}
    </div>
  );
}
